import React, { useEffect, useState, useRef } from "react";
import { useTheme } from "../../hooks/useTheme";
import CustomChannel from "./components/CustomChannel";
import CustomMessageList from "./components/CustomMessageList";
import MessagePageTopBar from "./components/MessagePageTopBar";
import CustomMessageInput from "./components/CustomMessageInput";
import { useTextSearch } from "../../hooks/useTextSearch";
import DialogSendWallet from "./components/DialogSendWallet";
import { resetTransaction, SendTransactionStateRecipient } from "../../store/slices/transactionSlice";
import { useParams, useLocation } from "react-router-dom";
import { useTransaction } from "../../hooks/useTransaction";
import { WithDragAndDropUpload } from "stream-chat-react";
import { groupRepository } from "../../repositories/GroupRepository";
import { useAuth } from "../../hooks/useAuth";

interface MessagePageProps {}

export const MessagePage: React.FC<MessagePageProps> = () => {
    const {isMobile} = useTheme();
    const { isTextInputFocused } = useTextSearch();
    const [isDialogSendWalletOpen, setIsDialogSendWalletOpen] = useState(false);
    const [transactionStateRecipient, setTransactionStateRecipient] = useState<SendTransactionStateRecipient | null>(null);
    const [dialogPosition, setDialogPosition] = useState({ top: 0, right: 0 });
    const messageListRef = useRef<HTMLDivElement>(null);
    const { type, id } = useParams();
    const location = useLocation();
    const {pleb} = useAuth();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const joinParam = queryParams.get("join");
        
        if (joinParam === "true" && type === 'group' && id) {
            groupRepository.addMember(id, pleb?.id ?? '', true);
        }
    }, [type, id, location.search]);

    const handleOpenDialog = (data: SendTransactionStateRecipient) => {
        // Get the position of the message list
        if (messageListRef.current) {
            const rect = messageListRef.current.getBoundingClientRect();
            // Center the dialog in the message list
            setDialogPosition({
                top: rect.top,
                right: window.innerWidth - rect.right
            });
        }

        setTransactionStateRecipient(data);
        setIsDialogSendWalletOpen(!isDialogSendWalletOpen);
    };

    return (
        <CustomChannel>
            <MessagePageTopBar
                onClickSend={handleOpenDialog}
            >
                <WithDragAndDropUpload className="flex-grow overflow-y-auto flex flex-col">
                    <div ref={messageListRef} className="flex-grow overflow-y-hidden relative">
                        <CustomMessageList />
                        <DialogSendWallet 
                            transactionStateRecipient={transactionStateRecipient}
                            visible={isDialogSendWalletOpen}
                            onClose={() => setIsDialogSendWalletOpen(false)}
                            position={dialogPosition}
                        />
                    </div>
                    <div className={
                        `border-t border-brand-border-color flex grow-0 shrink-0 bg-brand-bg-4
                        ${isMobile ? 'pb-[15px] min-h-[70px]' : 'min-h-[60px]'}
                        `
                    }>
                        <CustomMessageInput 
                            shouldFocus={! isTextInputFocused}
                        />
                    </div>
                </WithDragAndDropUpload>
            </MessagePageTopBar>
        </CustomChannel>
    );
};

export default MessagePage;